import type { ComponentProps, ReactNode } from 'react'
import { cn } from '../../lib/cn'

/** The row of search and filters above a console table; it wraps on a narrow screen. */
export function FilterBar({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div
      role="search"
      aria-label={label}
      className="flex flex-wrap items-center gap-3 rounded-card border border-line bg-surface p-3"
    >
      {children}
    </div>
  )
}

/** A filter as a list to choose from; its name is read out, the first option says «all». */
export function FilterSelect({
  label,
  className,
  children,
  ...props
}: ComponentProps<'select'> & { label: string }) {
  return (
    <label className="block min-w-0 flex-[1_1_11rem]">
      <span className="sr-only">{label}</span>
      <select
        className={cn(
          'w-full truncate rounded-lg border border-line bg-surface px-3 py-2 text-sm disabled:opacity-60',
          className,
        )}
        {...props}
      >
        {children}
      </select>
    </label>
  )
}
